import React, { useEffect, useRef } from 'react';
import MotionReveal from '../motion/MotionReveal';
import FormulationFinder from '../components/FormulationFinder';

const FORMULATION_VIDEO = `${process.env.PUBLIC_URL || ''}/videos/formulation-path.mp4`;

export default function FinderCtaSection() {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const video = videoRef.current;
    if (!section || !video) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.playbackRate = 1;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="sec sec-process-wrap finder-cta-wrap finder-cta-wrap--video-bg"
      data-palette="gold"
    >
      <div className="finder-cta__video-bg" aria-hidden="true">
        <video
          ref={videoRef}
          className="finder-cta__video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          disablePictureInPicture
        >
          <source src={FORMULATION_VIDEO} type="video/mp4" />
        </video>
      </div>
      <div className="sec-process-content finder-cta-sec">
        <MotionReveal className="finder-cta-sec__panel">
          <div className="kicker k-gold">Solution Finder</div>
          <h2>Find your formulation path</h2>
          <p>
            Tell us your market, polymer and performance need — we&apos;ll connect you with the right Auralux technical
            team within 24 hours.
          </p>
          <FormulationFinder triggerLabel="Launch Formulation Finder" />
        </MotionReveal>
      </div>
    </section>
  );
}
